import { useContext } from 'react'
import { VerificationPreferencesContext } from '@/contexts/VerificationPreferencesContext'

export function useVerificationPreferences() {
    const context = useContext(VerificationPreferencesContext)
    if (!context) {
        throw new Error(
            'useVerificationPreferences must be used within a VerificationPreferencesProvider'
        )
    }
    return context
}
